import axios from 'axios';

export default function init ({ el, context }) {

	const nodeSelectors = {
    listingBody: el
  }

  const apiUrl = Shopify.theme.name.downcase.contains('dev') ? 'http://shopify-app-local.eu.ngrok.io' : 'http://mapi-app.herokuapp.com'

  const getOrderData = async (customerId) => {
    return axios.get(`${apiUrl}/api/customers/previous_orders?shopify_customer_id=${customerId}`)
  }

	const buildOrders = async (orders) => {    
    for (var i = orders.length - 1; i >= 0; i--) {
      appendOrder(orders[i].order_data)
    }
  }

  const noOrders = () => {
    nodeSelectors.listingBody.innerHTML = "<h1>You have 0 previous orders</h1>"
  }

  const appendOrder = async (order) => {
    var orderLineItems = ""
    for (var i = order.line_items.length - 1; i >= 0; i--) {
      var lineItem = `<div class="orders__previous__order__row__line-items__item"><span class="item-title">${order.line_items[i].title}</span></div>`
      orderLineItems = orderLineItems + lineItem
    }
  	nodeSelectors.listingBody.innerHTML = `<div class="orders__previous__order">
      <div class="orders__previous__order__row">
        <div class="orders__previous__order__row__line-items">
          ${orderLineItems}
        </div>
        <div class="orders__previous__order__row__content">
          <span class="order-status">Delivered</span>
        </div>
      </div>
    </div>`
  }

  const onLoad = async () => {
    const customerId = parseInt(nodeSelectors.listingBody.dataset.customerId)
    const orderData = await getOrderData(5025741635774)
    
    const orders = orderData.data
    
    if(orders.data !== null) {
      buildOrders(orders.data)
    } else {
      noOrders()
    }
  }
  onLoad()
}